import React from 'react';
import { Box, Button, CircularProgress, Stack, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ProductForm from '../components/ProductForm';
import { useGetProductHandler } from '../dataHandlers/getProductHandler';
import TopBar from '../../../components/TopBar';

export default function ProductDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { product, isLoading } = useGetProductHandler(id);
  const theme = useTheme();

  function onClickingBackButton() {
    return navigate('/products');
  }

  if (isLoading || !product) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box>
        <TopBar title="Product Details" subTitle={product?.id} identifier={product?.id}>
          <Button
            data-testid="product-profile-back-button"
            key="back"
            variant="contained"
            color="primary"
            onClick={onClickingBackButton}
            className="action-button"
            sx={{ marginLeft: theme.spacing(1) }}
          >
            Back
          </Button>
        </TopBar>
      </Box>
      <ProductForm readOnly={true} initialData={product} onCancel={() => navigate('/products')} />
    </Stack>
  );
}
